var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative"},[_c('iframe',{staticStyle:{"overflow":"hidden","height":"100vh","width":"100%"},attrs:{"src":_vm.getSrc(),"frameborder":"0","height":"100%","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }